export const ASTRO_STATIC_IMPORT_YAML = `project:
  name: recipe-astro
  tags:
    - zerops-recipe

services:
  - hostname: app
    type: static
    enableSubdomainAccess: true
    buildFromGit: https://github.com/zeropsio/recipe-astro-static`;
